window.addEventListener('DOMContentLoaded', () => {
  const dataPlan = localStorage.getItem('plan')
  if (dataPlan) {
    // Get plan from datastorage
    let planObject = JSON.parse(dataPlan)
    if (planObject && planObject.step2 && planObject.step2.url) {
      $('a[href="/pages/get-started"]:not([data-step="1"])').attr('href', planObject.step2.url)
      $('a[data-step="2"]').attr('href', planObject.step2.url)

      // Save quantity on change
      const $increaseQtyButton = $('.dd_product_details .dd_product_select .increase_qty')
      const $decreaseQtyButton = $('.dd_product_details .dd_product_select .decrease_qty')
      const $quantityInput = $('.dd_product_details .dd_product_select .quantity__input')
      function setStep2Quantity() {
        planObject = {
          ...planObject,
          step2: {
            ...planObject.step2,
            quantity: $quantityInput.val()
          }
        }
        localStorage.setItem('plan', JSON.stringify(planObject))
      }
      // $increaseQtyButton.on('click', setStep2Quantity)
      // $decreaseQtyButton.on('click', setStep2Quantity)

      // Save delivery day on click
      const $deliveryDayInput = $('.dd_product_details .dd_form_inputs .dd_product_select_label input[name="id"]')
      $deliveryDayInput.on('click', function(event) {
        planObject = {
          ...planObject,
          step2: {
            ...planObject.step2,
            delivery_date: $(this).val()
          }
        }
        localStorage.setItem('plan', JSON.stringify(planObject))
      })

      // Save and load selling plan
      const sellingPlanInt = setInterval(function() {
        if ($('.dd_product_details select[name="selling_plan"]').length > 0) {
          setTimeout(function() {
            $('.dd_product_details select[name="selling_plan"]').on('change', function(event) {
              
              planObject = {
                ...planObject,
                step2: {
                  ...planObject.step2,
                  selling_plan: $(this).val()
                }
              }
              localStorage.setItem('plan', JSON.stringify(planObject))
            })
      
            if (planObject.step2.selling_plan) {
              $('.dd_product_details select[name="selling_plan"]').val(planObject.step2.selling_plan)
            }
          }, 100)
              
          clearInterval(sellingPlanInt);
        }
      }, 100);

      // Set Values
      // if (planObject.step2.quantity) {
      //   $quantityInput.val(Number(planObject.step2.quantity))
      // }
      
      if (planObject.step2.delivery_date) {
        $('.dd_product_details .dd_form_inputs .dd_product_select_label input[name="id"][value="' + planObject.step2.delivery_date + '"]').prop('checked', true)
      }
    }
  }

  console.log('dataPlan', dataPlan)

  let sidePlanSelect = document.querySelector('.side-plan-select');
  let sidePlan = document.querySelector('.side-plan__plan');
  if (sidePlanSelect) {
    sidePlanSelect.addEventListener('change', function(event) {
      let plan = event.target.value;
      if (plan == 'subscription') {
        sidePlan.removeAttribute('disabled');
      } else {
        sidePlan.setAttribute('disabled', 'disabled');
      }
    });
  }

  let addToCart = document.querySelector('.atc-btn')
  if (addToCart) {
    addToCart.addEventListener('click', function(event) {
      event.preventDefault()
      let variant = addToCart.dataset.variant;
      let quantity = 1;

      let body = {
        id: variant,
        quantity: quantity
      }

      if (!sidePlan.hasAttribute('disabled')) {
        body.selling_plan = sidePlan.value;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        window.location.href = '/cart';
      });
    })
  }

  let isCustomFlow = localStorage.getItem('custom_flow')
  let excludedRoutes = [
    '/products/gift-delivery',
    '/products/occasional-dabba',
    '/products/dabbadrop-one-off',
  ]

  if (false) {
    document.body.classList.add('custom-flow')
    let productLinks = document.querySelectorAll('a[href*="/products/"]');
    productLinks.forEach(function(link) {
      let href = link.href.replace('https://dabbadrop.co.uk', '');
      if (excludedRoutes.includes(href)) {
        return;
      }
      link.href = '/products/dabbadrop-dinner-subscription';
    });
  }
});